module.exports = __webpack_public_path__ + "img/Protability-4.18efe4d.jpg";